// Banka Transferi (bankadan bankaya) penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'finance.bankToBankTransfer';

export const bankToBankTransferGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Banka transferi nasıl yapılır?'),
  intro: t(`${G}.intro`, 'Bu pencere, bir banka hesabınızdaki parayı başka bir banka hesabınıza aktarır. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Banka Transferi'),
    body: t(`${G}.regions.body`, 'Kaynak, hedef ve tutar'),
    footer: t(`${G}.regions.footer`, 'Transfer Yap'),
  },
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. Kaynak hesabı kontrol edin'),
      text: t(`${G}.s1.text`, 'Üstteki Kaynak Hesap kutusu, transferi başlattığınız hesabı ve mevcut bakiyesini gösterir. Para bu hesaptan çıkar. Alt hesap satırından açtıysanız kaynak o alt hesaptır.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Hedef banka hesabını seçin'),
      text: t(`${G}.s2.text`, 'Hedef Banka Hesabı listesinde yalnız kaynak hesapla aynı para birimindeki diğer banka hesapları görünür. Hedef hesabın uygun alt hesapları varsa "Alt Hesap (Opsiyonel)" alanı açılır; boş bırakırsanız para ana hesaba gider.'),
      tips: [
        t(`${G}.s2.tip1`, 'Kaynağın bağlı olduğu banka hesabı ve onun alt hesapları hedef listesinde çıkmaz.'),
        t(`${G}.s2.tip2`, 'Şube yöneticisi olarak girdiyseniz yalnız kendi şubenizin hesapları listelenir.'),
        t(`${G}.s2.tip3`, '"Uygun banka hesabı bulunamadı" yazıyorsa aynı para biriminde başka hesabınız yoktur.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Miktar, açıklama ve tarih'),
      text: t(`${G}.s3.text`, 'Miktarı 1.500,50 biçiminde girin; kaynak hesabın bakiyesinden fazla olamaz ("Yetersiz bakiye!"). Açıklama isteğe bağlıdır; boş bırakılırsa "Kaynak → Hedef banka transferi" yazılır.'),
      tips: [
        t(`${G}.s3.tip1`, '"Geçmiş tarihli işlem yap" işaretlenirse seçtiğiniz tarihe kayıt yapılır; ileri tarih seçilemez. Kayıt tamamen o tarihe ait olur.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s4.title`, '4. Transferi tamamlayın'),
      text: t(`${G}.s4.text`, '"Transfer Yap" hedef hesap ve geçerli bir miktar girilince açılır. Onaydan sonra tutar kaynak hesabın bakiyesinden düşülür, hedef hesabın bakiyesine eklenir; iki hesapta da hareket kaydı oluşur ve belge numarası (BBT-…) otomatik verilir. Pencere kısa bir başarı mesajından sonra kapanır.'),
      tips: [
        t(`${G}.s4.tip1`, 'Hatalı transferi düzeltmek için ters yönde yeni bir transfer yapın.'),
      ],
    },
  ],
});
